import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import styles from './styles.module.scss';
import Loading from 'components/Loading';
import { LOADING_SM } from 'constants/index.js';

// Trạng thái AI đọc CV, đặt dưới ô upload CV của form tạo ứng viên
const CvParseStatus = ({ isLoading, result }) => {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className={classNames(styles.cvParseStatus, styles.loading)}>
        <Loading type={LOADING_SM} />
        <span>{t('managerCandidate.aiParsing')}</span>
      </div>
    );
  }
  if (!result) return null;
  if (result.error) {
    return <div className={classNames(styles.cvParseStatus, styles.error)}>{result.error}</div>;
  }

  return (
    <div className={classNames(styles.cvParseStatus, result.count ? styles.success : styles.error)}>
      {result.count
        ? t('managerCandidate.aiParseSuccess', { count: result.count })
        : t('managerCandidate.aiParseEmpty')}
    </div>
  );
};

export default CvParseStatus;
